export function formatMoney(value: number | null | undefined) {
  if (value === null || value === undefined) return '-';
  if (Number.isNaN(value)) return '-';
  try {
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(value);
  } catch {
    return String(value);
  }
}

export function formatDate(value: string | null | undefined) {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  try {
    return new Intl.DateTimeFormat('es-ES', { dateStyle: 'medium' }).format(date);
  } catch {
    return value;
  }
}

export function formatUnknownDate(value: unknown) {
  if (Array.isArray(value) && value.length >= 3) {
    const [year, month, day] = value;
    const y = Number(year);
    const m = Number(month);
    const d = Number(day);

    if ([y, m, d].some((part) => !Number.isFinite(part))) return '-';

    return formatDate(`${String(y).padStart(4, '0')}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`);
  }

  return formatDate(typeof value === 'string' ? value : null);
}

export function formatJson(value: unknown) {
  if (value === null || value === undefined || value === '') return '-';
  if (typeof value === 'string') return value;
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}
